import React, { useState } from "react";
import './WebDesign.css';
import mobilesolutions from './assets/mobilesolutions.avif';
import approachsolutions from './assets/approachsolutions.avif';
import mobileoffer from './assets/mobileoffer.jpg';

const MobileSolutions = () => {
    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Mobile Solutions</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Mobile Solutions</span>
                        </p>
                    </div>
                </div>
            </section>

            <div className="company-section py-5">
                <div className="container">

                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <h2>Mobile Solutions – Bringing Your Business to Every Device</h2>
                            <p>With mobile internet usage surpassing desktop, it’s vital that your digital presence is optimized for smartphones and tablets. At Dot Localhost, we provide mobile-friendly solutions that ensure your website or app delivers an exceptional experience no matter what device your audience uses. We specialize in creating mobile apps and responsive websites that bring your brand to life on the go.</p>
                            <h3>Why Mobile Solutions Matter</h3>
                            <p>In today’s digital landscape, a significant portion of web traffic comes from mobile devices. Users expect seamless experiences, fast loading speeds, and intuitive navigation. A poorly optimized mobile experience can result in lost customers and lower engagement rates. That’s why we prioritize mobile-first design principles to enhance accessibility, usability, and overall user satisfaction.</p>
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={mobilesolutions} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 side-images py-5">
                            <img src={approachsolutions} alt="Mobile Optimization" className="mt-3" />
                        </div>
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>Our Approach to Mobile Solutions</h3>                                
                                <ol>
                                    <li><b>Strategic Planning:</b> Understanding your audience and business goals to develop the best mobile strategy.</li>
                                    <li><b>Custom Design & Development:</b> Creating responsive websites and mobile apps tailored to your brand.</li>
                                    <li><b>Optimization & Performance:</b> Ensuring fast load times, smooth navigation, and cross-platform compatibility.</li>
                                    <li><b>Testing & Deployment:</b> Rigorous testing to guarantee a flawless user experience before launch.</li>
                                </ol>
                            </div>
                        </div>                        
                    </div>

                    <div className="row">                        
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>What We Offer</h3>                                
                                <ol>
                                    <li><b>Responsive Mobile Websites:</b> Optimized for smartphones and tablets to enhance user engagement.</li>
                                    <li><b>Custom iOS and Android Mobile Apps:</b> Tailored app development for seamless brand interaction.</li>
                                    <li><b>Cross-Platform Solutions:</b> Ensuring accessibility across multiple devices and operating systems.</li>
                                    <li><b>Mobile-First Web Design:</b> Prioritizing mobile usability to capture every user effectively.</li>
                                </ol>
                            </div>
                        </div> 
                        <div className="col-md-6 side-images py-5">
                            <img src={mobileoffer} alt="Mobile Optimization" className="mt-3" />
                        </div>                       
                    </div>

                    <section className="hero-section text-column mt-5">
                        <p>A mobile-friendly digital presence is no longer optional—it’s essential. At Dot Localhost, we design and develop high-performing mobile solutions that help businesses stay ahead in a mobile-driven world. Let us transform your digital presence and create experiences that engage users wherever they are.</p>
                    </section>

                </div>
            </div>
        </>
    );
};

export default MobileSolutions;